/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingPaymentMethod } from './BillingPaymentMethod';
import {
    BillingPaymentMethodFromJSON,
    BillingPaymentMethodFromJSONTyped,
    BillingPaymentMethodToJSON,
    BillingPaymentMethodToJSONTyped,
} from './BillingPaymentMethod';

/**
 * 
 * @export
 * @interface UpdatePaymentMethodResponse
 */
export interface UpdatePaymentMethodResponse {
    /**
     * 
     * @type {BillingPaymentMethod}
     * @memberof UpdatePaymentMethodResponse
     */
    data: BillingPaymentMethod;
}

/**
 * Check if a given object implements the UpdatePaymentMethodResponse interface.
 */
export function instanceOfUpdatePaymentMethodResponse(value: object): value is UpdatePaymentMethodResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdatePaymentMethodResponseFromJSON(json: any): UpdatePaymentMethodResponse {
    return UpdatePaymentMethodResponseFromJSONTyped(json, false);
}

export function UpdatePaymentMethodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentMethodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingPaymentMethodFromJSON(json['data']),
    };
}

  export function UpdatePaymentMethodResponseToJSON(json: any): UpdatePaymentMethodResponse {
      return UpdatePaymentMethodResponseToJSONTyped(json, false);
  }

  export function UpdatePaymentMethodResponseToJSONTyped(value?: UpdatePaymentMethodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingPaymentMethodToJSON(value['data']),
    };
}

